module.exports = __webpack_public_path__ + "BA.png?252eb01f5acc452f56f2dd0609ae06d3";